import React from "react";

const TransportationEquipmentIcon = ({
  color = "#5D5D5D",
  width = "23",
  height = "23",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0938 7.1875H17.0104C17.2979 7.1875 17.5854 7.37916 17.7771 7.57082L19.4062 10.0625L21.6104 10.8292C21.9937 10.925 22.2812 11.3083 22.2812 11.6917V15.8125C22.2812 16.2917 21.8979 16.7708 21.3229 16.7708H18.4593"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5319 18.6888C17.5905 18.6888 18.4486 17.8307 18.4486 16.7721C18.4486 15.7136 17.5905 14.8555 16.5319 14.8555C15.4733 14.8555 14.6152 15.7136 14.6152 16.7721C14.6152 17.8307 15.4733 18.6888 16.5319 18.6888Z"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0937 15.5164V5.27083C15.0937 4.69583 14.7104 4.3125 14.1354 4.3125H1.67708C1.10208 4.3125 0.71875 4.69583 0.71875 5.27083V15.8125C0.71875 16.2917 1.10208 16.7708 1.67708 16.7708H3.11194M14.609 16.7708H10.7789"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.0319 18.6888C6.09045 18.6888 6.94857 17.8307 6.94857 16.7721C6.94857 15.7136 6.09045 14.8555 5.0319 14.8555C3.97335 14.8555 3.11523 15.7136 3.11523 16.7721C3.11523 17.8307 3.97335 18.6888 5.0319 18.6888Z"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.86393 18.6888C9.92251 18.6888 10.7806 17.8307 10.7806 16.7721C10.7806 15.7136 9.92251 14.8555 8.86393 14.8555C7.80539 14.8555 6.94727 15.7136 6.94727 16.7721C6.94727 17.8307 7.80539 18.6888 8.86393 18.6888Z"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.03125 4.3125V11.0208"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.82251 4.3125V11.0208"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TransportationEquipmentIcon;
